import React, { useEffect, useState, forwardRef, useContext, useImperativeHandle } from 'react';
import { DataObjectContext } from './DataObjectContextManager';
import { Regex } from './Regex';
import { SkipBack, SkipForward } from 'react-feather'; 

import './BoundControls.css';


export const BoundCheckbox = ({ propertyName, className }) => {

    const dataObjectContextManager = useContext(DataObjectContext);
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();    
    const [value, setValue] = React.useState(val !== null ? val == true : false);

    const getDefaultValue = () => {
        var val = property.getValue();
        return val !== true ? true : false;
    }

    useEffect(() => {
        property.setValid(isValid(val));
    }, []);

    const handleChange = (event) => {
        var input = event.target.value;

        setValue(input);
        property.setValue(input);

        var vld = isValid(input);
        property.setValid(vld);
    };

    const isValid = (value) => {
        return true;
    }

    return (
        <input id={propertyName} type='checkbox' className={`control checkbox ${className} ${isValid(value) ? 'valid' : 'error'}`} value={getDefaultValue()} onChange={handleChange} />
    )
}


export const PageableList = forwardRef(({ className, pageSize, pageIndex, onRenderRow, onRenderHeaderRow, filter, defaultText, loadAll }, ref) => {

    const dataObjectContextManager = useContext(DataObjectContext);
    const [references, setReferences] = React.useState([]);
    const [items, setItems] = React.useState([]);
    const [index, setIndex] = React.useState(pageIndex ? pageIndex : 0);
    const [previousEnabled, setPreviousEnabled] = React.useState(false);
    const [nextEnabled, setNextEnabled] = React.useState(false);
    const [ready, setReady] = React.useState(null);
    
    useEffect(() => {
        if (loadAll) {
            loadAllAsync();
        }
        else {
            loadAsync();
        }       
    }, [pageSize, pageIndex]);

    useImperativeHandle(ref, () => ({

        refresh() {
            if (loadAll) {
                loadAllAsync();
            }
            else {
                loadAsync();
            } 
        }

    }));

    const loadAllAsync = async () => {
        if (ready == null) {
            setReady(false);
        }
       
        var response = await dataObjectContextManager.list(0, 100000, filter);

        setPreviousEnabled(false);
        setNextEnabled(false);

        setReferences(response.references);
        setItems(response.value.items);
        setIndex(response.value.pageIndex);
        setReady(true);
    }

    const loadAsync = async (pageIndex) => {
        if (ready == null) {
            setReady(false);
        }
        var response = await dataObjectContextManager.list(pageIndex ? pageIndex : 0, pageSize ? pageSize : 20, filter);

        setPreviousEnabled(response.value.pageIndex > 0);
        setNextEnabled(response.value.items && response.value.items.length == pageSize);

        setReferences(response.references);
        setItems(response.value.items);
        setIndex(response.value.pageIndex);        
        setReady(true);
    }

    const onPreviousClick = async () => {
        var idx = index > 0 ? index - 1 : 0;        
        await loadAsync(idx);
    }

    const onNextClick = async () => {
        var idx = index + 1;
        await loadAsync(idx);
    }

    const showTable = () => {
        return items && items.length === 0 && index === 0
            ? false
            : true;
    }

    return (
        <div className={className ? `list ${className}` : `list`}>
            {ready &&
                <div>
                    <div className='table'>
                        {onRenderHeaderRow &&
                            onRenderHeaderRow()
                        }

                        <div className='table-body'></div>
                        {showTable() && onRenderRow && items.map((item, idx) => {
                            return (
                                onRenderRow(item.key, item.dataObject, references, idx)
                            )
                        })}
     
                    </div>

                    {showTable()
                        ?
                        <div>
                            {!loadAll &&
                                <button disabled={!previousEnabled} className='btn btn-secondary-outline' onClick={onPreviousClick}><SkipBack className='icon' /><span className='text'>Previous</span></button>
                            }
                            {!loadAll &&
                                <button disabled={!nextEnabled} className='btn btn-secondary-outline pull-right' onClick={onNextClick}><SkipForward className='icon' /><span className='text'>Next</span></button>
                            }
                        </div>
                        :
                        <div><p>{defaultText}</p></div>
                    }
                    
                </div>
            }
        </div>
        )
});


export const RenderConditionally = ({ propertyName, value, children }) => {
    const dataObjectContextManager = useContext(DataObjectContext);
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();

    return (
        <>
            {value == val &&
                <>
                    {children}
                </>
            }
        </>
    )
}


export const BoundLabel = ({ propertyName }) => {
    const dataObjectContextManager = useContext(DataObjectContext);
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();

    return (
        <span id={propertyName}>{val}</span>
    )
}


export const BoundTextbox = ({ propertyName, className }) => {

    const dataObjectContextManager = useContext(DataObjectContext);    
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();
     
    const maxLength = property.hasStringLength() && property.getStringLength().maximumLength > 0 ? property.getStringLength().maximumLength : null;
    const [value, setValue] = React.useState(val !== null ? val : '');

    const getDefaultValue = () => {
        var val = property.getValue();
        return val !== null ? val : '';
    }

    useEffect(() => {
        property.setValid(isValid(val));
    }, []);

    const handleChange = (event) => {
        var input = event.target.value;
        if (property.hasRegex() && !Regex.Matches(property.getRegex().expression, input)) {
            return;
        }

        setValue(input);
        property.setValue(input);

        var vld = isValid(input);
        property.setValid(vld);
    };

    const isValid = (value) => {

        if (property.isRequired()) {
            if (!value) {
                return false;
            }
        }
        else {
            if (value && value.length > 0) {
                if (property.hasStringLength()) {
                    if (property.getStringLength().minimumLength && value.length < property.getStringLength().minimumLength) {
                        return false;
                    }
                    if (property.getStringLength().maximumLength && value.length > property.getStringLength().maximumLength) {
                        return false;
                    }
                }

                if (property.hasRegex() && !Regex.Matches(property.getRegex().expression, value)) {
                    return false;
                }
            }

        }
        return true;
    }

    return (
        <input id={propertyName} type='text' className={`control textbox ${isValid(value) ? 'valid' : 'error'} ${className}`} maxLength={maxLength} value={getDefaultValue()} onChange={handleChange} />
    )
}


export const BoundTextarea = ({ propertyName, className, rows, cols }) => {

    const dataObjectContextManager = useContext(DataObjectContext);
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();

    const maxLength = property.hasStringLength() && property.getStringLength().maximumLength > 0 ? property.getStringLength().maximumLength : null;
    const [value, setValue] = React.useState(val !== null ? val : '');

    const getDefaultValue = () => {
        var val = property.getValue();
        return val !== null ? val : '';
    }

    useEffect(() => {
        property.setValid(isValid(val));
    }, []);

    const handleChange = (event) => {
        var input = event.target.value;

        if (property.hasRegex() && !Regex.Matches(property.getRegex().expression, input)) {
            return;
        }

        setValue(input);
        property.setValue(input);

        var vld = isValid(input);
        property.setValid(vld);
    };

    const isValid = (value) => {

        if (property.isRequired()) {
            if (!value) {
                return false;
            }
        }
        else {
            if (value && value.length > 0) {
                if (property.hasStringLength()) {
                    if (property.getStringLength().minimumLength && value.length < property.getStringLength().minimumLength) {
                        return false;
                    }
                    if (property.getStringLength().maximumLength && value.length > property.getStringLength().maximumLength) {
                        return false;
                    }
                }

                if (property.hasRegex() && !Regex.Matches(property.getRegex().expression, value)) {
                    return false;
                }
            }

        }
        return true;
    }

    return (
        <textarea id={propertyName} className={`control textbox textarea ${isValid(value) ? 'valid' : 'error'} ${className}`} rows={rows ? rows : null} cols={cols ? cols : null} maxLength={maxLength} value={getDefaultValue()} onChange={handleChange} />
    )

}




export const BoundDropdownList = ({ propertyName, className }) => {

    const dataObjectContextManager = useContext(DataObjectContext);
    const property = dataObjectContextManager.getProperty(propertyName);
    const val = property.getValue();

    const [items, setItems] = useState(null);
    const [value, setValue] = React.useState(val !== null ? val : -1);


    const getDefaultValue = () => {
        var val = property.getValue();
        return val !== null ? val : -1;
    }

    useEffect(() => {

        const init = async () => {

            var dataSource = property.getDataSource();
            if (!dataSource) {
                throw new Error('DataSource is not supported!');
            }

            var items = await dataSource.getItems();
            setItems(items);            
            
            if (property.isRequired() && !val) {
                var v = items[0].id;
                setValue(v);
                property.setValue(v);                
            }
            property.setValid(isValid(val));     
        }

        init();            

    }, []);

    const handleChange = (event) => {
        var val = event.target.value;
        setValue(val);
        property.setValue(val);
        property.setValid(isValid(val));        
    };

    const isValid = (val) => {        

        if (property.isRequired() && val === -1) {            
            return false;
        }
        
        return true;
    }



    return (
        <div>
            {items &&
                <select id={propertyName} className={`control dropdown ${isValid(value) ? 'valid' : 'error'} ${className}`} value={getDefaultValue()} onChange={handleChange}>

                    {!property.isRequired() && 
                        <option value={null}>Please select...</option>
                    }

                    {items.map((item, idx) => {
                        return (
                            <option key={`option${idx}`} value={item.id}>{item.name}</option>
                            )                        
                    })}

                </select>
            }
        </div>
    )
}




export const DataSourceDropdownList = ({ id, className, dataSourceName, filter, onChanged }) => {

    const dataObjectContextManager = useContext(DataObjectContext);

    const [items, setItems] = useState(null);


    useEffect(() => {

        const init = async () => {
            var items = await dataObjectContextManager.getDataSourceItems(dataSourceName, filter);
            setItems(items);
        }
        init();
    }, []);

    const handleChange = (event) => {
        var val = event.target.value;
        if (onChanged) {
            onChanged(val);
        }
    };


    return (
        <div>
            {items &&
                <select id={id} className={`control dropdown'} ${className}`} onChange={handleChange}>
                    <option value={''}>Please select...</option>

                    {items.map((item, idx) => {
                        return (
                            <option key={`option${idx}`} value={item.id}>{item.name}</option>
                        )
                    })}
                </select>
            }
        </div>
    )
}
